import React from "react";
import Slider from "react-slick"; // npm install react-slick slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import langData from '../locales/langData.json'
import { FaLinkedinIn } from "react-icons/fa6";
import { Link } from "react-router-dom";

function BoardSection({ language }) {
  // Mobile slider settings

  const board = langData[language].company.board;
  const director = langData[language].company.board.director;

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="container board-sec" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="row">
        <div className="col-md-6">
          <h6 className="sec-top-titl">{board.boardtoptitle}</h6>
          <h2 className="sece-title">{board.boardtitle}</h2>
          <p className="sec-p">{board.boarddesc}</p>
        </div>
        <div className="col-md-6"></div>
      </div>

      {/* Desktop Grid */}
      <div className="row d-none d-md-flex">
        {director.map((dir, index) => (
          <div className="col-md-3" key={index}>
            <div className="img-slide-boxs">
              <img src={dir.img} alt={dir.name} />
              <div className="member-detail">
                <Link
                  to={dir.link}
                  className="people-linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </Link><h5 className="mem-name">{dir.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Slider */}
      <div className="d-md-none mt-4">
        <Slider {...settings}>
          {director.map((dir, index) => (
            <div className="img-slide-boxs text-center" key={index}>
              <img src={dir.img} alt={dir.name} className="mobile-slide-img" />
              <div className="member-detail">
                <Link 
  to={dir.link} 
  className="people-linkedin" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <FaLinkedinIn />
</Link><h5 className="mem-name">{dir.name}</h5>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default BoardSection;
